import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="mx-auto max-w-5xl px-4 py-12 md:py-14" data-id="element-113" data-mp="1o3x3nprb6w3l">
      <div className="flex flex-col items-center gap-5 rounded-3xl border-2 border-sky-200 bg-white p-6 text-center shadow-sm md:flex-row md:p-8 md:text-left" data-id="element-114" data-mp="1o5q1cfjy25zg">
        <span className="inline-flex shrink-0 rounded-full border-2 border-sky-600 bg-sky-50 p-4" data-id="element-115" data-mp="1x5d3j3khzftk">
          <ShieldIcon className="h-9 w-9 text-sky-600" data-id="element-116" data-mp="19fskkkocgika" />
        </span>
        <div data-id="element-117" data-mp="14fxugjce7x0a">
          <h2 className="text-lg font-black uppercase text-slate-900 md:text-xl" data-id="element-118" data-mp="14gfln1k77l1c">
            🛡️ Garantía de 7 días
          </h2>
          <p className="mt-2 text-sm font-semibold leading-relaxed text-slate-600" data-id="element-119" data-mp="1j650fzl7rnk3">
            Comprás el material, abrís los tomos y revisás los proyectos. Tenés{' '}
            <b className="text-slate-900" data-id="element-120" data-mp="qnhkeyl2qypv">7 días para comprobar si el contenido es lo que esperabas</b>.
            Si necesitás solicitar una devolución dentro del período correspondiente, escribís a:
          </p>
          <a href="mailto:compradigitalyaa@gmail.com" className="mt-2 inline-block text-base font-black text-sky-700 underline-offset-4 hover:underline md:text-lg" data-id="element-121" data-mp="oyqdc7f0ntim">
            compradigitalyaa@gmail.com
          </a>
        </div>
      </div>
    </section>;
}